export const translations = {
  nl: {
    // Nav
    home: "Home",
    about: "Over Ons",

    // Home intro
    welcome: "Welkom op",
    welcomeHighlight: "Parking Haarlem",
    homeIntro: "Bekijk hier de actuele bezettingsgraad van parkeergarages rond Haarlem. De gegevens worden elke 5 minuten bijgewerkt, zodat je altijd up-to-date informatie hebt. Zo voorkom je onnodig rondrijden of in de file staan!",
    homeDisclaimer: "Let op: dit is geen offici\u00eble website van de gemeente Haarlem.",

    // Meta
    metaHomeTitle: "Parking Haarlem | Realtime vrije parkeergarages",
    metaHomeDesc: "Parkeren in het centrum van Haarlem. Zie hoeveel parkeerplaatsen er vrij zijn in parkeergarages van Haarlem Centrum. Navigeer gemakkelijk naar de parkeergarage",
    metaAboutTitle: "Parking Haarlem | Over Ons",
    metaAboutDesc: "Parkeren in het centrum van Haarlem. Op deze pagina wordt beschreven waarom deze website gemaakt is en welke bronnen er gebruikt worden.",
    meta404Title: "Parking Haarlem | 404 - pagina niet gevonden",
    meta404Desc: "Parkeren in het centrum van Haarlem. Deze pagina geeft aan dat het door u verzochte pagina niet bestaat.",

    // Card
    ad: "Advertentie",
    free: "vrij",
    full: "VOL",
    updatedAt: "Bijgewerkt om",
    // Garage detail
    garageTitle: "Parkeergarage",
    freeSpots: "vrij",
    spotsTooltip: "Op dit moment zijn er {count} parkeerplaatsen vrij in parkeergarage {name}",
    moreInfo: "Meer Informatie",
    info: "Informatie",
    address: "Adres",
    clearance: "Doorrijhoogte",
    spots: "Parkeerplekken",
    freeOf: "van de",
    lastUpdated: "Laatst bijgewerkt",
    hour: "uur",
    routeTo: "Route naar",
    garageInfo: "Garage informatie",
    metaGarageTitle: "Parking Haarlem | Huidig beschikbare parkeerplaatsen bij parkeergarage",
    metaGarageDesc: "Parkeren in het centrum van Haarlem. Zie hoeveel parkeerplaatsen er op dit moment vrij zijn in parkeergarage {name}. Navigeer met \u00e9\u00e9n knop gemakkelijk naar parkeergarage {name}",

    // About
    aboutTitle: "Over Parking Haarlem",
    aboutWebsite: "Over deze website",
    aboutText: "Deze website biedt inzicht in het aantal vrije parkeerplaatsen in verschillende parkeergarages in Haarlem. De realtime data wordt verzameld via het opendata-platform van de gemeente Haarlem. Op deze pagina vind je een link naar de desbetreffende pagina en de gebruikte dataset.\n\nHeb je vragen of opmerkingen? Neem dan gerust contact op via het aangegeven e-mailadres op deze pagina.",
    aboutLinks: "Links & Contact",
    aboutContact: "Contact met websitebeheerder",
    aboutMunicipality: "Website van Gemeente Haarlem over de data",
    aboutDataset: "Gebruikte dataset (JSON)",

    // 404
    notFoundTitle: "404 - Pagina niet gevonden",
    notFoundText: "De pagina die u zoekt is niet gevonden. Klik op de onderstaande knop om naar de homepagina te gaan.",
    notFoundButton: "Terug naar Home",

    // Warning
    warningText: "Er zijn momenteel werkzaamheden aan de gang bij de parkeergarages. Hierdoor is de data mogelijk onjuist.",

    // Loader
    loading: "Gegevens ophalen...",

    // Alt texts
    altLogo: "Logo van Parking Haarlem",
    altGaragePhoto: "Foto van parkeergarage",
    alt404: "illustratie van een verkeersbord met 404",
    altAboutPhoto: "Foto van parkeergarage Dreef",
  },

  en: {
    // Nav
    home: "Home",
    about: "About Us",

    // Home intro
    welcome: "Welcome to",
    welcomeHighlight: "Parking Haarlem",
    homeIntro: "View the current occupancy of parking garages around Haarlem here. The data is updated every 5 minutes, so you always have up-to-date information. This way you avoid unnecessary driving around or sitting in traffic!",
    homeDisclaimer: "Note: this is not an official website of the municipality of Haarlem.",

    // Meta
    metaHomeTitle: "Parking Haarlem | Realtime available parking garages",
    metaHomeDesc: "Parking in the centre of Haarlem. See how many parking spaces are available in Haarlem parking garages. Easily navigate to the parking garage.",
    metaAboutTitle: "Parking Haarlem | About Us",
    metaAboutDesc: "Parking in the centre of Haarlem. This page describes why this website was created and which sources are used.",
    meta404Title: "Parking Haarlem | 404 - page not found",
    meta404Desc: "Parking in the centre of Haarlem. This page indicates that the page you requested does not exist.",

    // Card
    ad: "Advertisement",
    free: "free",
    full: "FULL",
    updatedAt: "Updated at",
    // Garage detail
    garageTitle: "Parking garage",
    freeSpots: "free",
    spotsTooltip: "Currently there are {count} parking spaces free in parking garage {name}",
    moreInfo: "More Information",
    info: "Information",
    address: "Address",
    clearance: "Clearance height",
    spots: "Parking spots",
    freeOf: "of",
    lastUpdated: "Last updated",
    hour: "",
    routeTo: "Navigate to",
    garageInfo: "Garage information",
    metaGarageTitle: "Parking Haarlem | Currently available parking spaces at parking garage",
    metaGarageDesc: "Parking in the centre of Haarlem. See how many parking spaces are currently available in parking garage {name}. Easily navigate to parking garage {name}",

    // About
    aboutTitle: "About Parking Haarlem",
    aboutWebsite: "About this website",
    aboutText: "This website provides insight into the number of available parking spaces in various parking garages in Haarlem. The realtime data is collected via the open data platform of the municipality of Haarlem. On this page you will find a link to the relevant page and the dataset used.\n\nDo you have any questions or comments? Feel free to contact us via the email address listed on this page.",
    aboutLinks: "Links & Contact",
    aboutContact: "Contact the website administrator",
    aboutMunicipality: "Municipality of Haarlem website about the data",
    aboutDataset: "Dataset used (JSON)",

    // 404
    notFoundTitle: "404 - Page not found",
    notFoundText: "The page you are looking for was not found. Click the button below to return to the homepage.",
    notFoundButton: "Back to Home",

    // Warning
    warningText: "There are currently maintenance works at the parking garages. The data may therefore be inaccurate.",

    // Loader
    loading: "Fetching data...",

    // Alt texts
    altLogo: "Parking Haarlem logo",
    altGaragePhoto: "Photo of parking garage",
    alt404: "illustration of a road sign with 404",
    altAboutPhoto: "Photo of parking garage Dreef",
  }
}
